import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";
import type { UiColor } from "simplydo/react/theme";
export type ColorSwatchProps = {
  color: UiColor;
  size?: number;
  className?: string;
};

const Swatch = styled.span<{ $color: UiColor; $size: number }>`
  display: inline-block;
  flex-shrink: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 4px;
  background-color: ${({ $color, theme }) => theme.colors[$color].solid};
  border: 1px solid rgba(0, 0, 0, 0.08);
`;

export function ColorSwatch({
  color,
  size = 14,
  className,
}: ColorSwatchProps): ReactElement {
  return (
    <Swatch className={cx(className)} $color={color} $size={size} aria-hidden />
  );
}
